import React, { Fragment, useCallback } from "react";
import { useLocalization } from "@fluent/react";
import styles from "./CheckManager.module.scss";
import TransactionCheck from "./TransactionCheck";
import type { CheckManagerProps } from "./types";

const CheckManager = ({
  images = [],
  transactionId,
  onSaveSuccess,
  onDescriptionUpdate,
}: CheckManagerProps) => {
  const { l10n } = useLocalization();

  const renderTransactionCheck = useCallback(
    (image: API.CheckImage, index: number) => {
      const { front, back } = image;
      const label = l10n.getString(
        "transaction-detail-check-label",
        { attachmentNumber: index + 1 },
        `Attachment #${index + 1}`
      );

      return (
        <TransactionCheck
          key={label}
          front={front}
          back={back}
          isCheck={image.is_check}
          label={label}
          payFrom={image.pay_from}
          payTo={image.pay_to}
          amount={image.amount}
          memo={image.memo}
          checkDate={image.check_date}
          checkNumber={image.check_number}
          checkDetailUuid={image.check_detail_uuid}
          transactionId={transactionId}
          onSaveSuccess={onSaveSuccess}
          onDescriptionUpdate={onDescriptionUpdate}
        />
      );
    },
    [l10n, transactionId, onSaveSuccess, onDescriptionUpdate]
  );

  if (!images.filter((img) => img.front || img.back).length) {
    return null;
  }

  const availableAttachments = images.filter((img) => img.front || img.back);

  return (
    <Fragment>
      <div className={styles.separator} />
      <div className={styles.container}>
        {availableAttachments.map(renderTransactionCheck)}
      </div>
    </Fragment>
  );
};

export default CheckManager;
